import axios from "../../privateApi";

export const getNumberOfPlayersInClub = async (uuid: string) => {
  const response = await axios.get("/players/count", {
    headers: { "x-auth-token": uuid },
  });
  return response.data;
};
